export const toString = (time) => {
  var getTime = new Date(time);
  const year = getTime.getFullYear();
  const month = getTime.getMonth() + 1;
  const date = getTime.getDate();
  return `${year}-${month >= 10 ? month : "0" + month}-${
    date >= 10 ? date : "0" + date
  }`;
};
